import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { Maths } from '../_app/cuchillo/utils/Maths';
import { ScrollItem__SliderDefault } from './ScrollItem__SliderDefault';

class ScrollItem__TitleImageText extends ScrollItem__SliderDefault {
  tick = 0;
  images = [];
  parents = [];

  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================
  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);

    this.images = GetBy.class('__img', __link);
    for (let i = 0; i < this.images.length; i++) {
      const item = this.images[i];
      const pos = {
        x: Maths.maxminRandom(-10, -20),
        y: Maths.maxminRandom(-10, -20)
      }

      const rot = Maths.maxminRandom(15, -15);
      item.style.transformOrigin = 'center center';
      item.style.transform = `rotate(${rot}deg) translate3D(${pos.x}%, ${pos.y}%, 0)`;
    }
  }

  showAnimation() { }
}

Scroll._registerClass('TitleImageText', ScrollItem__TitleImageText);